import React from "react";

import cn from "classnames";
import { useIntl } from "react-intl";

import IField from "@mapmycustomers/shared/types/fieldModel/IField";
import SavedFilter from "@mapmycustomers/shared/types/viewModel/SavedFilter";
import { Button } from "@mapmycustomers/ui";

import getAppliedFiltersCount from "@app/component/filtering/utils/getAppliedFiltersCount";
import useView from "@app/component/view/utils/useView";

import styles from "./Footer.module.scss";

interface Props {
  addDisabled?: boolean;
  className?: string;
  hideSavedFilters?: boolean;
  implicitFilterFields?: IField[];
  onAdd?: () => void;
  onCreateSavedFilter?: () => void;
  selectedFilter?: SavedFilter;
}

const Footer: React.FC<Props> = ({
  addDisabled,
  className,
  hideSavedFilters,
  implicitFilterFields,
  onAdd,
  onCreateSavedFilter,
  selectedFilter,
}) => {
  const intl = useIntl();
  const {
    viewState: { filter, viewAs },
  } = useView();

  return (
    <div className={cn(styles.container, className)}>
      <Button disabled={addDisabled} onClick={onAdd} size="small" type="default">
        {intl.formatMessage({
          id: "filters.addFilter",
          defaultMessage: "+ Add Rule",
          description: "Add Filter button in filters dropdown",
        })}
      </Button>
      {!selectedFilter && !hideSavedFilters && (
        <Button
          disabled={!getAppliedFiltersCount(filter, viewAs, implicitFilterFields)}
          onClick={onCreateSavedFilter}
          size="small"
          type="link"
        >
          {intl.formatMessage({
            id: "filters.save",
            defaultMessage: "Save this filter",
            description: "Save this filter button in filters dropdown",
          })}
        </Button>
      )}
    </div>
  );
};

export default Footer;
